const teamPlayers = [
  {
    id: 'rhea-hackin',
    shirtNumber: 1,
    firstName: 'Rhea',
    lastName: 'Hackin',
    position: 'outside',
    age: 20,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/rhea-hackin.png'
  },
  {
    id: 'chelsea-ezeagba',
    shirtNumber: 2,
    firstName: 'Chelsea',
    lastName: 'Ezeagba',
    position: 'middle',
    age: 21,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/chelsea-ezeagba.png'
  },
  {
    id: 'zoe-hopkins',
    shirtNumber: 3,
    firstName: 'Zoe',
    lastName: 'Hopkins',
    position: 'middle',
    age: 19,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/zoe-hopkins.png'
  },
  {
    id: 'maria-forson',
    shirtNumber: 4,
    firstName: 'Maria',
    lastName: 'Forson',
    position: 'outside/opposite',
    age: 22,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/maria-forson.png'
  },
  {
    id: 'louise-francois',
    shirtNumber: 5,
    firstName: 'Louise',
    lastName: 'Francois',
    position: 'outside/opposite',
    age: 20,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/louise-francois.png'
  },
  {
    id: 'charlotte-russell',
    shirtNumber: 6,
    firstName: 'Charlotte',
    lastName: 'Russell',
    position: 'outside',
    age: 21,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/charlotte-russell.png'
  },
  {
    id: 'zoe-morrison',
    shirtNumber: 7,
    firstName: 'Zoe',
    lastName: 'Morrison',
    position: 'setter',
    age: 19,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/zoe-morrison.png'
  },
  {
    id: 'maja-sankowska',
    shirtNumber: 8,
    firstName: 'Maja',
    lastName: 'Sankowska',
    position: 'outside/libero',
    age: 20,
    nationality: 'GBR',
    status: 'injured',
    photo: 'player-photos/maja-sankowska.png'
  },
  {
    id: 'leah-garvey',
    shirtNumber: 10,
    firstName: 'Leah',
    lastName: 'Garvey',
    position: 'setter',
    age: 20,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/leah-garvey.png'
  },
  {
    id: 'bel-lopez',
    shirtNumber: 11,
    firstName: 'Bel',
    lastName: 'Lopez',
    position: 'setter',
    age: 22,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/bel-lopez.png'
  },
  {
    id: 'audry-shelford',
    shirtNumber: 12,
    firstName: 'Audry',
    lastName: 'Shelford',
    position: 'setter',
    age: 21,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/audry-shelford.png'
  },
  {
    id: 'weronika-nycz',
    shirtNumber: 13,
    firstName: 'Weronika',
    lastName: 'Nycz',
    position: 'outside/opposite',
    age: 20,
    nationality: 'GBR',
    status: 'inactive',
    photo: 'player-photos/weronika-nycz.png'
  },
  {
    id: 'brooke-higgins',
    shirtNumber: 14,
    firstName: 'Brooke',
    lastName: 'Higgins',
    position: 'outside/opposite',
    age: 19,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/brooke-higgins.png'
  },
  {
    id: 'kira-kalsi',
    shirtNumber: 15,
    firstName: 'Kira',
    lastName: 'Kalsi',
    position: 'opposite',
    age: 22,
    nationality: 'GBR',
    status: 'unavailable',
    photo: 'player-photos/kira-kalsi.png'
  },
  {
    id: 'katie-white',
    shirtNumber: 16,
    firstName: 'Katie',
    lastName: 'White',
    position: 'middle',
    age: 21,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/katie-white.png'
  },
  {
    id: 'chloe-maggee',
    shirtNumber: 18,
    firstName: 'Chloe',
    lastName: 'Maggee',
    position: 'middle',
    age: 21,
    nationality: 'GBR',
    status: 'inactive',
    photo: 'player-photos/chloe-maggee.png'
  },
  {
    id: 'yuki-matsumoto',
    shirtNumber: 19,
    firstName: 'Yuki',
    lastName: 'Matsumoto',
    position: 'libero',
    age: 20,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/yuki-matsumoto.png'
  },
  {
    id: 'vanessa-godinho',
    shirtNumber: 20,
    firstName: 'Vanessa',
    lastName: 'Godinho',
    position: 'libero',
    age: 22,
    nationality: 'GBR',
    status: 'active',
    photo: 'player-photos/vanessa-godinho.png'
  }
];

export default teamPlayers;
